// extracted by mini-css-extract-plugin
module.exports = {"saleItem":"SaleItem_saleItem__i-eYY"};